module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-cyrillic-400-normal.woff2?71a33b6b50457b2c903a3a2312e8eea1";